import React from 'react';
import { Container } from 'react-bootstrap';
import SelectableCard from './SelectableCard';

function CheckboxField({ title, items, selectedValues = [], onChange }) {
  const handleToggle = value => {
    const newValues = selectedValues.includes(value)
      ? selectedValues.filter(v => v !== value)
      : [...selectedValues, value];
    onChange(newValues);
  };

  return (
    <Container className="question-field">
      {/* The blue info text box */}
      <div className="question-field__text" dangerouslySetInnerHTML={{ __html: title }} />
      {/* The checkbox(es) below */}
      <div className="question-field__checkbox-group">
        {items.map(item => (
          <label key={item.value} className="question-field__checkbox-option">
            <input
              type="checkbox"
              checked={selectedValues.includes(item.value)}
              onChange={() => handleToggle(item.value)}
              className="question-field__checkbox"
            />
            <span className="question-field__checkbox-label">{item.label}</span>
          </label>
        ))}
      </div>
    </Container>
  );
}

export default CheckboxField;
